import React, { useState } from 'react';
import './FolderTabs.css';

/**
 * FolderTabs — overlapping filing-cabinet style tabs.
 *
 * Props:
 *   tabs: Array<{ label: string, badge?: number, content: ReactNode }>
 *   defaultTab?: number  (index, defaults to 0)
 */
const FolderTabs = ({ tabs = [], defaultTab = 0 }) => {
    const [active, setActive] = useState(defaultTab);

    return (
        <div className="folder-tabs">
            <div className="folder-tabs-bar" role="tablist">
                {tabs.map((tab, i) => (
                    <button
                        key={i}
                        role="tab"
                        aria-selected={active === i}
                        aria-controls={`folder-panel-${i}`}
                        className={`folder-tab${active === i ? ' active' : ''}`}
                        onClick={() => setActive(i)}
                    >
                        <span className="folder-tab-label">{tab.label}</span>
                        {tab.badge > 0 && (
                            <span className="folder-tab-badge">{tab.badge}</span>
                        )}
                    </button>
                ))}
            </div>

            <div
                id={`folder-panel-${active}`}
                role="tabpanel"
                className="folder-tabs-panel"
            >
                {tabs[active]?.content}
            </div>
        </div>
    );
};

export default FolderTabs;
